dictAdapter.$inject = ['dictService', '$timeout']
export default function dictAdapter(dictService, $timeout) {
    return function (input, param) {
        const dictlist = dictService.dictData[param]
        for (const i in dictlist) {
            if (input == dictlist[i].enumCode) {
                return dictlist[i].enumName
            }
        }
        return input
    }
}



// WEBPACK FOOTER //
// ./src/common/services/dictAdapter.js